import { TransformNode } from '@babylonjs/core/Meshes/transformNode';

import { PositionEntity } from './positionEntity';
import { MeshSystem } from '../System/meshSystem';
import { Animation } from '../System/animation';

export class SatelliteEntity extends PositionEntity {

    public satelliteAnimation: Animation;

    public offset = 0; // Used to determine beginning position around gravityEntity

    public cycle = 0; // Around its gravityEntity % Math.PI

    public stationaryRadius = 1;
    
    public stationaryVelocity = 1;

    constructor(type: string, system: MeshSystem) {
        super(type, system);
        this.satelliteAnimation = new Animation(system.animationManager);
    }

    public setGeostationnaryMovement(stationaryRadius: number, stationaryVelocity: number) {
        this.stationaryRadius = stationaryRadius;
        this.stationaryVelocity = Math.max(stationaryVelocity, 2);
    }
    
    public setParent(parent: TransformNode) {
        this.transformMesh.parent = parent;
    }

    public setOffset(offset: number) {
        this.offset = offset;
    }
}